(() => {
  const ZXING_CDN = "https://unpkg.com/@zxing/browser@0.1.5/umd/index.min.js";

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function buildOverlay() {
    const overlay = document.createElement("div");
    overlay.id = "barcode-scan-overlay";
    overlay.style.cssText = `
      position:fixed; inset:0; z-index:999999;
      background:rgba(0,0,0,.92);
      display:flex; flex-direction:column;
    `;

    overlay.innerHTML = `
      <div style="display:flex; gap:10px; align-items:center; justify-content:space-between; padding:12px;">
        <div style="color:#fff; font-size:16px; font-weight:600;">Scan barcode</div>
        <button id="barcode-scan-close" style="padding:10px 12px; font-size:14px; cursor:pointer;">Close</button>
      </div>

      <div style="position:relative; flex:1;">
        <video id="barcode-scan-video"
          style="width:100%; height:100%; object-fit:cover;"
          playsinline muted></video>

        <div style="
          position:absolute; left:10%; right:10%; top:40%;
          height:90px; border:2px solid rgba(255,255,255,.9);
          border-radius:10px;">
        </div>

        <div id="barcode-scan-status"
          style="position:absolute; left:0; right:0; bottom:18px; text-align:center; color:#fff; font-size:14px; opacity:.9;">
          Point your camera at a barcode…
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    return overlay;
  }

  async function tryShopifySuggest(code) {
    // Attempts to find a product/variant match via Shopify's suggest endpoint.
    // Works best when code matches SKU/title/etc.
    const url =
      `/search/suggest.json?q=${encodeURIComponent(code)}` +
      `&resources[type]=product,variant` +
      `&resources[limit]=4` +
      `&resources[options][unavailable_products]=hide`;

    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return null;

    const data = await res.json();

    // Prefer variants if returned (SKU matches often show here).
    const variants = data?.resources?.results?.variants || [];
    if (variants.length && variants[0]?.url) return variants[0].url;

    const products = data?.resources?.results?.products || [];
    if (products.length && products[0]?.url) return products[0].url;

    return null;
  }

  function isMobile() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  window.CreartBarcodeScan = {
    open: async function () {
      if (!isMobile()) {
        alert("Barcode scanning is intended for mobile devices.");
        return;
      }

      // Load ZXing if not already loaded
      if (!window.ZXing?.BrowserMultiFormatReader) {
        try {
          await loadScript(ZXING_CDN);
        } catch (e) {
          alert("Scanner failed to load. Please try again.");
          return;
        }
      }

      const overlay = buildOverlay();
      const videoEl = overlay.querySelector("#barcode-scan-video");
      const closeBtn = overlay.querySelector("#barcode-scan-close");
      const statusEl = overlay.querySelector("#barcode-scan-status");

      const codeReader = new window.ZXing.BrowserMultiFormatReader();
      let stopped = false;

      async function cleanup() {
        if (stopped) return;
        stopped = true;
        try { codeReader.reset(); } catch (e) {}
        overlay.remove();
      }

      closeBtn.addEventListener("click", cleanup);

      try {
        // Use default camera (usually rear on mobile)
        const result = await codeReader.decodeOnceFromVideoDevice(undefined, videoEl);
        const code = (result && result.text) ? result.text.trim() : "";

        if (!code) {
          statusEl.textContent = "Couldn’t read barcode. Try again.";
          await cleanup();
          return;
        }

        statusEl.textContent = `Scanned: ${code} — searching…`;

        // Try Shopify suggest first (best chance to go straight to product)
        const matchUrl = await tryShopifySuggest(code);

        await cleanup();

        if (matchUrl) {
          window.location.href = matchUrl;
        } else {
          // Fallback to normal search results
          window.location.href = `/search?q=${encodeURIComponent(code)}`;
        }
      } catch (err) {
        await cleanup();
        alert("Couldn’t access camera or scan failed. Please allow camera permission and try again.");
      }
    }
  };
})();
